<div class="loading" [hidden]="!isLoading">
    @if (showEpcotSpinner) {
        <div class="epcot-spinner">
            @for (number of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; track number) {
                <div></div>
            }
        </div>
    } @else {
        @if (universalLoader) {
            <div [ngClass]="loadingVersion">
                <div class="dot-flashing"></div>
            </div>
        } @else {
            <span class="loading-v1"></span>
        }
    }
</div>
